import { createRoot } from "solid-js"
import type { Engine } from "../../../../lib/core/engine/Engine.type"
import { SelectedToolId } from "../../../../lib/core/map_editor/SelectedToolId.enum"
import createDefaultPointerSelectionInputActionHandler from "../../../../lib/event/InputRouter/InputActionHandler/createDefaultPointerSelectionInputActionHandler"
import { InputActionType } from "../../../../lib/event/InputRouter/InputActionType"
import { mountInputActionListener } from "../../../../lib/event/InputRouter/mountInputActionListener"

export default function createFillTool(engine: Engine) {
  return createRoot((dispose) => {
    const handlePrimary = createDefaultPointerSelectionInputActionHandler(engine)

    mountInputActionListener(InputActionType.Primary, handlePrimary)

    return {
      id: SelectedToolId.Fill,
      actions: {
        [InputActionType.Primary]: handlePrimary,
      },
      dispose,
    }
  })
}